import { render } from "./AttachmentFiles.vue?vue&type=template&id=3ec9a23c&scoped=true"
import script from "./AttachmentFiles.vue?vue&type=script&lang=js"
export * from "./AttachmentFiles.vue?vue&type=script&lang=js"

import "./AttachmentFiles.vue?vue&type=style&index=0&id=3ec9a23c&scoped=true&lang=css"
import "./AttachmentFiles.vue?vue&type=style&index=1&id=3ec9a23c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec9a23c"]])

export default __exports__